// src/services/api.js
import axios from 'axios';
import { API_BASE_URL } from '../config'; // ✅ Utilise config.js

console.log('🔧 API Service configuré avec:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL, // ✅ Utilise directement API_BASE_URL (qui contient déjà /api)
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Intercepteur pour ajouter le token
api.interceptors.request.use(
  (config) => {
    // ✅ Vérifier si c'est une requête affilié
    const isAffiliateRequest = config.url?.includes('/affiliates');
    
    if (isAffiliateRequest) {
      // Utiliser le token affilié
      const affiliateToken = localStorage.getItem('affiliateToken');
      if (affiliateToken) {
        config.headers.Authorization = `Bearer ${affiliateToken}`;
        console.log('🔑 Token AFFILIÉ ajouté à la requête');
      }
    } else {
      // Utiliser le token user normal
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        console.log('🔑 Token USER ajouté à la requête');
      }
    }
    
    console.log('📤 Requête Axios:', {
      method: config.method?.toUpperCase(),
      url: config.url,
      baseURL: config.baseURL,
      fullURL: `${config.baseURL}${config.url}`,
      isAffiliate: isAffiliateRequest
    });
    return config;
  },
  (error) => {
    console.error('❌ Erreur intercepteur request:', error);
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs de réponse
api.interceptors.response.use(
  (response) => {
    console.log('✅ Réponse Axios:', {
      status: response.status,
      url: response.config.url
    });
    return response;
  },
  (error) => {
    console.error('❌ Erreur réponse Axios:', {
      status: error.response?.status,
      message: error.message,
      url: error.config?.url
    });
    
    // ✅ Vérifier si c'est une requête affilié
    const isAffiliateRequest = error.config?.url?.includes('/affiliates');
    
    // Déconnexion automatique si token invalide
    if (error.response?.status === 401) {
      if (isAffiliateRequest) {
        // ✅ Pour les affiliés : rediriger vers login affilié
        console.log('🚪 Token affilié invalide, redirection vers /affiliates/login');
        localStorage.removeItem('affiliateToken');
        localStorage.removeItem('affiliateInfo');
        
        // Ne rediriger que si on n'est pas déjà sur la page login affilié
        if (!window.location.pathname.includes('/affiliates/login')) {
          window.location.href = '/affiliates/login';
        }
      } else {
        // Pour les users normaux : rediriger vers login normal
        console.log('🚪 Token user invalide, redirection vers /login');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;